module.exports = __webpack_public_path__ + "img/toolbar_zgsf.558e41be.png";